/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_RepliedInputs */

const en_admin_tickets_status_replied = /** @type {(inputs: Admin_Tickets_Status_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const zh_admin_tickets_status_replied = /** @type {(inputs: Admin_Tickets_Status_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Admin_Tickets_Status_RepliedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_replied = /** @type {((inputs?: Admin_Tickets_Status_RepliedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_RepliedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_status_replied(inputs)
	return zh_admin_tickets_status_replied(inputs)
});
export { admin_tickets_status_replied as "admin.tickets.status_replied" }